import { IntrestChartConfigurationModel } from "./IntrestChartConfigurationModel";
import { SchemeInstallmentConfigurationModel } from "./SchemeInstallmentConfigurationModel";
import { TenementListResponse } from "./TenementListResponse";

export class TenementInsConfigInitModel {
    constructor(
    public key: number,
	public tenementKey: number,
	public installmentType: string,
	public installmentAmount: number,
	public displayOrder: number,
	public instPaymentStartDate: string,
	public instPaymentEndDate: string,
	public instPaymentInterestRate: number,
	public instPaymentEndDateWithInterest: string,
	public installmentStartPaymentDays: number,
	public installmentDuePaymentDays: number,
	public installmentDuePaymentDaysWithInterest: number,
	public otherCharge: string,
    public tenementInstKey: number,
    public installmentPercent: number,
    public lotteryKey: number,
	public intrestChartLst: IntrestChartConfigurationModel[],
	public corrigendumDocFile: string | ArrayBuffer,
	public isRecordUpdated: string = "false",
	public corrigendumDocFileName: string,
    // public intrestChartLst:  [{
	// 							key: number,
	// 							startDate: string,
	// 							endDate: string,
	// 							instPaymentInterestRate: number,
	// 							tenementConfiguration: number,
	// 							installmentType: string,
	// 						}],
    ) { }
}